$(document).ready(function() {
	if (iCreateObject.isSiteInICreateMode) {
		$(".homepage #homeBanner").content_manager(
			{
				skin: "basic",
				skinVersion: "1.2.0",
				baseUrl: "https://js.esolutionsgroup.ca/js/libs/jquery_icreate_contentmanager/",
				tokenID: "TKBanner",
				manageButtonText: "Manage Banner and Video",
				tokenType: "html", //html or json
				wrapperHTMLStructure: "<div id='bannerAreaWrapper'></div>",
				innerHTMLStructures: [
					{
						innerStructure: "<div id='bannerContainer' class='{banneyOverlay}'><img class='lazy' data-src='{bannerImg}' alt='{bannerImageAlt}' /></div><div id='backgroundVideoWrapper' class='{toggleOption}'><video id='backgroundVideo' playsinline autoplay muted loop poster='{bannerImg}'><source src='{webmVideo}' type='video/webm'/></video><source src='{mp4Video}' type='video/mp4'><source src='{og4Video}' type='video/ogg'></video><button class='pauseButton'><span class='assistiveTech-only'>Pause</span></button><button class='toggleSound'></button></div>",
						wrapperTarget: "#bannerAreaWrapper",
						targetType: "element" //element or attribute
					}
				],
				fileManagerUrls: [
					"/230002_FileManager/Plugins/FileManager/FileManagerPlugin.js"
				],
				useEsolFileManager: true,
				maxItems: 1,
				sortableFieldBinding: "bannerImg",
				sortableFieldType: "image", //image or text
				fields: [
					{
						type: "FileField",
						id: "webmVideo",
						name: "Video (webm)",
						required: true,
						invalidMessage: "Video is a required field"
					},
					{
						type: "FileField",
						id: "mp4Video",
						name: "Video (mp4)",
						required: false,
						invalidMessage: "Video is a required field"
					},
					{
						type: "FileField",
						id: "og4Video",
						name: "Video (ogv)",
						required: false,
						invalidMessage: "Video is a required field"
					},
					{
						type: "ImageField",
						id: "bannerImg",
						name: "Banner Image",
						required: true,
						imageResizerMode: "fixed",//"max" or "fixed", max allow user to set it smaller
						imageResizerWidth: "1600px",
						imageResizerHeight: "842px",
						invalidMessage: "Banner Image is a required field"
					},
					{
						type: "TextField",
						id: "bannerImageAlt",
						name: "Alt Text",
						required: false,
						invalidMessage: "Banner Alt Text is a required field"
					},
					{
						type: "OptionList",
						id: "toggleOption",
						name: "Banner/Video",
						required: true,
						optionName: "optionlist",
						options: [
							{
								id: "optHideImage",
								name: "Show Banner Image",
								optionValue: "noVideo"
							},
							{
								id: "optHideVideo",
								name: "Show Video",
								optionValue: "showVideo"
							}
						]
					},
					{
						type: "OptionList",
						id: "banneyOverlay",
						name: "Banner Overlay",
						required: true,
						optionName: "optBanneyOverlay",
						options: [
							{
								id: "optBrandOne",
								name: "20% Overlay",
								optionValue: "overlayOpacity-20"
							},
							{
								id: "optBrandTwo",
								name: "40% Overlay",
								optionValue: "overlayOpacity-40"
							}
							,
							{
								id: "optBrandThree",
								name: "60% Overlay",
								optionValue: "overlayOpacity-60"
							}
							,
							{
								id: "optBrandFour",
								name: "80% Overlay",
								optionValue: "overlayOpacity-80"
							}
						]
					}

				]


			},
			iCreateObject
		);
		$(".homepage .videoCarousel").content_manager(
			{
				skin: "basic",
				skinVersion: "1.2.0",
				baseUrl: "https://js.esolutionsgroup.ca/js/libs/jquery_icreate_contentmanager/",
				tokenID: "TKVideoContent",
				manageButtonText: "Manage Video Scroller - MAX 7",
				tokenType: "html", //html or json
				wrapperHTMLStructure: "<div class=\"videoContainer_slider\"></div><div class=\"videoModalWrapper hide\"></div>",
				innerHTMLStructures: [
					{
						innerStructure:
							"<div class=\"slide\" data-modal-id=\"video_{itemIndex}\"><img src=\"{img}\" alt=\"{altText}\"/><div><h2>{headingText}</h2><p>{subHeadingText}</p></div></div>",
						wrapperTarget: ".videoContainer_slider",
						targetType: "element" //element or attribute
					},
					{
						innerStructure:
							"<div class=\"modal-box video-modal\" id=\"video_{itemIndex}\"><div class=\"modal-body\">{content}<a href=\"#\" class=\"js-modal-close\">&times;</a></div></div>",
						wrapperTarget: ".videoModalWrapper",
						targetType: "element" //element or attribute
					}
				],
				fileManagerUrls: [
					"/230002_FileManager/Plugins/FileManager/FileManagerPlugin.js"
				],
				useEsolFileManager: true,
				maxItems: 7,
				sortableFieldBinding: "headingText",
				sortableFieldType: "text", //image or text
				fields: [
					{
						type: "TextField",
						id: "headingText",
						name: "Heading",
						required: true,
						invalidMessage: "Heading Text is a required field"
					},
					{
						type: "TextField",
						id: "subHeadingText",
						name: "Sub Heading Text",
						required: false,
						invalidMessage: "Sub Heading Text is a required field"
					},
					{
						type: "ImageField",
						id: "img",
						name: "Image (740w X 424h)",
						required: true,
						imageResizerMode: "fixed",
						imageResizerWidth: "740px",
						imageResizerHeight: "424px",
						invalidMessage: "Image is a required field"
					}, {
						type: "TextField",
						id: "altText",
						name: "Image Alt Text",
						required: false,
						invalidMessage: "Image Alt Text is a required field"
					},
					{
						type: "RichTextArea",
						id: "content",
						name: "iFrame/Video",
						required: true,
						invalidMessage: "iFrame/Video is a required field"
					}
				],
				editorSettings: $.extend({}, iCreateObject.isSiteInICreateMode ? $.fn.tinyMCE_iCreate_defaults.standardTextAreaSettings : {},
					{
						theme_advanced_blockformats: "p",
						theme_advanced_buttons1: "icrtsave,|,media,|,code",
						theme_advanced_buttons2: "",
						theme_advanced_buttons3: "",
						theme_advanced_buttons4: "",
						plugins: "media"
					}, (iCreateObject.isSiteInICreateMode && !iCreateObject.isSiteInPreviewMode ? { "theme_advanced_styles": "" } : {})
				)
			},
			iCreateObject
		);
	}
});